import { eq } from 'rise-ui/utils/choice.js';

export const ITEM_STRUCTURE_TYPE_IDS = {
  TIME_SERIES: 1,
  GEOSPATIAL: 2,
  BINARY: 3,
};

export function itemTypeIdsEqual(...ids) {
  return eq(...ids);
}
